module.exports = __webpack_public_path__ + "img/cs-icons-facebook-filled.25899432.svg";